export default {
  list: { lazy: () => import('./WebhookProcessLogList') },
  options: {
    list: {
      title: 'Webhook Logs',
      breadCrumb: 'Webhook Logs',
    },
  },
}
